import request from '@/utils/request'


// 查询工种列表
export function listCategory(query) {
  return request({
    url: '/category/category/list',
    method: 'get',
    params: query
  })
}

// 查询工种分页
export function pageCategory(query) {
  return request({
    url: '/category/category/page',
    method: 'get',
    params: query
  })
}

// 查询工种详细
export function getCategory(data) {
  return request({
    url: '/category/category/detail',
    method: 'get',
    params: data
  })
}

// 新增工种
export function addCategory(data) {
  return request({
    url: '/category/category/add',
    method: 'post',
    data: data
  })
}

// 修改工种
export function updateCategory(data) {
  return request({
    url: '/category/category/edit',
    method: 'post',
    data: data
  })
}

// 删除工种
export function delCategory(data) {
  return request({
    url: '/category/category/delete',
    method: 'post',
    data: data
  })
}
